export const playerOptions = {
  i18n: {
    restart: "最初から再生",
    rewind: "巻き戻し",
    play: "再生",
    pause: "一時停止",
    fastForward: "早送り",
    seek: "シーク",
    seekLabel: "{seektime} 秒進みます",
    played: "再生済み",
    buffered: "バッファ済み",
    currentTime: "現在の時間",
    duration: "再生時間",
    volume: "音量",
    mute: "ミュート",
    unmute: "ミュート解除",
    enableCaptions: "字幕を有効にする",
    disableCaptions: "字幕を無効にする",
    download: "ダウンロード",
    enterFullscreen: "全画面表示",
    exitFullscreen: "全画面終了",
    settings: "設定",
    menuBack: "戻る",
    speed: "再生速度",
    normal: "標準",
    quality: "画質",
    loop: "ループ",
  },
};
